export default __webpack_public_path__ + "static/media/edit-copy.743240bf.png";